import React from "react";
import { LayoutContainer } from "assets/js/Styles";
import HomeNavbar from "./navbar";

const LandingPageLayout = ({ children }) => {
  return (
    <LayoutContainer>
      <HomeNavbar />
      {children}
    </LayoutContainer>
  );
};

export default LandingPageLayout;
